import { configureDomain } from "./configure-domain"

import { maulConfig } from "./fsp-config-maul"
import { tiffinConfig } from "./fsp-config-tiffin"

const module = "fsp-config.js"

// TODO We want to decide on whether to use fsp config for maul or tiffin at build time,
// that is more natural as we know when we deploy to app.tiffin.dk that we should use the
// tiffin fsp config and vice versa for maul.
// It's a bit silly to make every client do this calculation themselves, like we're doing it now.
// Here's a suggestion from the AI on how we could go about doing this.
// https://chatgpt.com/share/68aeebf3-e610-8003-b4c7-b58187cb5b94
// const domain = window.location.hostname
const domain = "localhost"

const domainConfig = configureDomain(domain)
const fspId = domainConfig.fspId

const fspConfigs = {
  maul: maulConfig,
  tiffin: tiffinConfig,
}

const _fspConfig = fspConfigs[fspId]
console.log("🚚", { module })
export const fspConfig = _fspConfig
